export const LINK_MOVIE = {
    path: '/trang-phim',
}

export const LINK_TV_CHANEL = {
    path: '/livetv',
}

export const LINK_SPORTS = {
    path: '/the-thao',
}

export const LINK_TV_SHOW = {
    path: '/tvshow',
}

export const LINK_OTHER = {
    path: '/khac',
}


// WEBPACK FOOTER //
// ./src/links/linksHome.js